let endpoints = {
    backendHost: 'https://localhost:44319',
    backendHost2: 'https://sbx-billing-api-staging.azurewebsites.net',
    environment: 'development'
};

const hostname = window && window.location && window.location.hostname;
if (hostname === 'me.securibox.eu') {
    endpoints.backendHost = 'https://securibox-id-api-v2.azurewebsites.net';
    endpoints.environment = 'production';
} else {
    endpoints.backendHost = 'https://securibox-id-api-v2-staging.azurewebsites.net';
    endpoints.backendHost2 = 'https://sbx-billing-api-staging.azurewebsites.net';
    endpoints.environment = 'development';
}
export const EndPoints = endpoints;